package com.patronat.top.ui.molecules.actions

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.ButtonType

@Composable
fun FormFooterActions(
    cancelText: String,
    submitText: String,
    onCancelClick: () -> Unit,
    onSubmitClick: () -> Unit,
    modifier: Modifier = Modifier,
    submitLeadingIcon: Painter? = null,
    cancelEnabled: Boolean = true,
    submitEnabled: Boolean = true,
    submitLoading: Boolean = false
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val isCompact = maxWidth < 560.dp

        if (isCompact) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                AppButton(
                    text = cancelText,
                    onClick = onCancelClick,
                    type = ButtonType.BrownOutline,
                    enabled = cancelEnabled,
                    modifier = Modifier.fillMaxWidth()
                )

                AppButton(
                    text = submitText,
                    onClick = onSubmitClick,
                    type = ButtonType.BrownFilled,
                    enabled = submitEnabled,
                    isLoading = submitLoading,
                    leadingIcon = submitLeadingIcon,
                    modifier = Modifier.fillMaxWidth()
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                AppButton(
                    text = cancelText,
                    onClick = onCancelClick,
                    type = ButtonType.BrownOutline,
                    enabled = cancelEnabled,
                    modifier = Modifier.weight(1f)
                )

                AppButton(
                    text = submitText,
                    onClick = onSubmitClick,
                    type = ButtonType.BrownFilled,
                    enabled = submitEnabled,
                    isLoading = submitLoading,
                    leadingIcon = submitLeadingIcon,
                    modifier = Modifier.weight(1f)
                )
            }
        }
    }
}
